var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "question-content-show d-flex flex-column" },
    [
      _c("v-layout", [
        _vm.show
          ? _c("div", {
              staticClass: "question-body-preview-client p-4",
              domProps: { innerHTML: _vm._s(_vm.content) },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.currentQuestion.isDescriptionQuestion
        ? _c(
            "v-card-title",
            [
              _c(
                "v-layout",
                [
                  _vm.getAnswerMode() && _vm.show
                    ? _c("div", {
                        staticClass: "markdown-editor w-full",
                        staticStyle: { "min-height": "560px" },
                        attrs: { id: "editor" },
                      })
                    : _vm.currentQuestion.isTextarea && _vm.show
                    ? _c("Simplemde", {
                        key: "markdownEditor_q_" + _vm.currentQuestion.id,
                        ref: "markdownEditor_q_" + _vm.currentQuestion.id,
                        staticClass: "w-full",
                        attrs: {
                          name: "markdownEditor_q_" + _vm.currentQuestion.id,
                          rows: _vm.currentQuestion.textareaRowNumber,
                          "preview-class": "markdown-body",
                        },
                        on: { input: _vm.textareaOnChange },
                        model: {
                          value: _vm.text,
                          callback: function ($$v) {
                            _vm.text = $$v
                          },
                          expression: "text",
                        },
                      })
                    : _vm.currentQuestion.isCheckbox ||
                      _vm.currentQuestion.isMultiCheckbox
                    ? _c("QuestionCheckBox", {
                        attrs: {
                          list: _vm.currentQuestion.answerItemsView
                            ? _vm.currentQuestion.answerItemsView
                            : [],
                          callBackChange: _vm.callBackChange,
                          value: _vm.value ? _vm.value : [],
                          readonly: _vm.time === 0,
                          color: "white",
                        },
                      })
                    : _vm.currentQuestion.isRadio
                    ? _c("QuestionRadio", {
                        attrs: {
                          list: _vm.currentQuestion.answerItemsView
                            ? _vm.currentQuestion.answerItemsView
                            : [],
                          callBackChange: _vm.callBackChangeOne,
                          value: _vm.value.length ? _vm.value[0] : "",
                          readonly: _vm.time === 0,
                          color: "white",
                        },
                        on: {
                          "update:value": function ($event) {
                            return _vm.$set(
                              _vm.value,
                              "length ? value[0] : ''",
                              $event
                            )
                          },
                        },
                      })
                    : _vm.currentQuestion.isSelect
                    ? _c("QuestionSelect", {
                        attrs: {
                          list: _vm.currentQuestion.answerItemsView
                            ? _vm.currentQuestion.answerItemsView
                            : [],
                          callBackChange: _vm.callBackChange,
                          value: _vm.value ? _vm.value : [],
                          readonly: _vm.time === 0,
                          color: "white",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }